import React, { useState, useCallback } from 'react';

const ProjectItemEditor = ({ project, index, onProjectChange, onProjectDelete }) => {
  // Local state for the description.
  const [localDescription, setLocalDescription] = useState(
    Array.isArray(project.description)
      ? project.description.join("\n")
      : project.description || ""
  );

  // Use useCallback at the top level of this component.
  const handleLocalDescriptionChange = useCallback((e) => {
    setLocalDescription(e.target.value);
  }, []);

  // When the textarea loses focus, update the global state.
  const handleBlur = () => {
    const updatedProject = { ...project, description: localDescription.split("\n") };
    onProjectChange(index, updatedProject);
  };

  return (
    <div style={{ border: '1px solid #ccc', padding: '10px', marginBottom: '10px' }}>
      <label>Project Title</label>
      <input
        type="text"
        value={project.projectTitle}
        onChange={(e) => {
          const updatedProject = { ...project, projectTitle: e.target.value };
          onProjectChange(index, updatedProject);
        }}
      />
      <label>Description</label>
      <textarea
        value={localDescription}
        onChange={handleLocalDescriptionChange}
        onBlur={handleBlur}
        style={{ whiteSpace: 'pre-wrap' }}
      />
      {onProjectDelete && (
        <button onClick={() => onProjectDelete(index)}>
          Delete Project
        </button>
      )}
    </div>
  );
};

export default ProjectItemEditor;
